var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootItemCarouselNextButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#C4C4C4",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 12.75C21.1562 12.75 10.75 23.1562 10.75 36C10.75 48.8438 21.1562 59.25 34 59.25C46.8438 59.25 57.25 48.8438 57.25 36C57.25 23.1562 46.8438 12.75 34 12.75ZM44.5938 34.4062C45.5312 35.3438 45.5312 36.75 44.5938 37.5938L31.9375 50.3438C31.0938 51.1875 29.5938 51.1875 28.75 50.3438L27.1562 48.75C26.3125 47.9062 26.3125 46.4062 27.1562 45.5625L36.7188 36L27.1562 26.5312C26.3125 25.6875 26.3125 24.1875 27.1562 23.3438L28.75 21.75C29.5938 20.9062 31.0938 20.9062 31.9375 21.75L44.5938 34.4062Z",
    fill: "white",
    fillOpacity: 0.88
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootItemCarouselNextButton);
export default __webpack_public_path__ + "static/media/FootItemCarouselNextButton.149ebde6bb1d3a167418a7fdb7b56534.svg";
export { ForwardRef as ReactComponent };